export default {
  MuiTabPanel: {
    root: {
      width: '100%',
    },
  },
};
